export default __webpack_public_path__ + "media/images/big-slider-image-e77339fe62d309943b843d247c1dfb4a.jpg";